import { memo } from 'react';
import { styled } from 'styled-components';

import { RichText } from '#/components/Text/RichText';
import type { CmsApiFreeCodeBlockData } from '#/modules/cms/api/types/blocks/CmsApiFreeCodeBlock';

import { emailSignupBlockCss } from './emailSignupBlock';

const StyledRichText = styled(RichText)`
  ${emailSignupBlockCss}
`;

type Props = {
  data: CmsApiFreeCodeBlockData;
};

/**
 * We use memo because the block can contain scripts tag
 * that add event handlers that are lost when re-rendering.
 */
export const CmsFreeCodeBlock = memo(
  function CmsFreeCodeBlock({ data: { code } }: Props) {
    return (
      <section>
        <StyledRichText
          dangerouslySetInnerHTML={{
            __html: code,
          }}
        />
      </section>
    );
  },
  // Always return true = never re-render after initial mount
  () => true,
);
